<template>
  <p class="fast-title text-2xl font-medium text-dark sm:text-3xl" v-html="value"></p>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
